var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "backbone", "underscore"], function (require, exports, backbone_1, underscore_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Themeable = void 0;
    exports.serializeStylingText = serializeStylingText;
    exports.serializeStylingForModule = serializeStylingForModule;
    exports.applyTheme = applyTheme;
    backbone_1 = __importDefault(backbone_1);
    underscore_1 = __importDefault(underscore_1);
    const THEME_SCHEMA = {
        colors: ["color", {
                "primary": { "var": {} },
                "secondary": {},
                "title": {},
                "standard": {},
                "additional": {},
                "link": {},
                "linkHover": {}
            }],
        backgroundColor: {
            "primary": {},
            "secondary": {},
            "surface": {},
            "surfaceContainer": {},
            "surfaceHover": {},
            "checkbox": {}
        },
        padding: {},
        margin: {},
        "typography.fontSize": ["font-size", {
                "sm": {},
                "base": {},
                "lg": {},
                "xl": {},
                "heading1": {},
                "heading2": {},
                "heading3": {},
                "heading4": {},
            }],
        "typography.fontWeight": ["font-weight", {
                "title": {},
                "fieldTitle": { deprecated: true }
            }],
        "typography.fontFamily": ["font", {
                "primary": {},
                "secondary": {}
            }],
        "borderWidth": {},
        "borderColor": {},
        "borderStyle": {},
    };
    function lookupStylingVarName(property, prefix) {
        prefix = prefix || "";
        const schema = THEME_SCHEMA;
        const path = property.split(".");
        let key = "";
        let schemaEntry = null;
        let i = 0;
        for (; i < path.length && schemaEntry == null; ++i) {
            key += path[i];
            if (key in schema) {
                // get the key in the schema.
                schemaEntry = schema[key];
                i++;
                break;
            }
            key += ".";
        }
        if (!schemaEntry) {
            return null;
        }
        if (i >= path.length) {
            return null;
        }
        let name = key;
        if (underscore_1.default.isArray(schemaEntry)) {
            name = schemaEntry[0];
            schemaEntry = schemaEntry[1];
        }
        var restOfKey = path.slice(i).join(".");
        if (!(restOfKey in schemaEntry)) {
            return null;
        }
        return "--" + prefix + dashForm(name) + "-" + dashForm(restOfKey);
    }
    function theme2Vars(theme) {
        // use THEME_SCHEMA
        const schema = THEME_SCHEMA;
        let result = {};
        for (const key of Object.keys(schema)) {
            const path = key.split(".");
            var obj = path.reduce((obj, pe) => {
                return obj == null ? obj : obj[pe];
            }, theme);
            if (!obj) {
                console.log("path", path, "not found in theme");
                // TODO get defaults.
                continue;
            }
            var section = schema[key];
            var varPrefix = key;
            if (underscore_1.default.isArray(section)) {
                varPrefix = section[0];
                section = section[1];
            }
            else {
                varPrefix = dashForm(varPrefix);
            }
            for (const varName of Object.keys(section)) {
                var value = (obj && obj[varName]) || null;
                const varSchema = section[varName];
                const dashForm = varName.replace(/[A-Z]/g, ch => "-" + ch.toLowerCase());
                const destVarName = "--" + varPrefix + "-" + dashForm;
                if (value) {
                    result[destVarName] = value;
                }
            }
        }
        return result;
    }
    const dashForm = (varName) => varName.replace(/[A-Z]/g, ch => "-" + ch.toLowerCase());
    function serializeAsEntries(key, entry, varLookup) {
        function renderEntry(entry) {
            if (typeof entry == "string") {
                return entry;
            }
            else if (typeof entry == "object") {
                const keys = Object.keys(entry);
                if (keys.length == 1 && keys[0] == "var") {
                    const varName = (entry["var"]);
                    const varResult = varLookup(varName);
                    if (!varResult) {
                        return null;
                    }
                    return `var(${varResult})`;
                }
            }
        }
        if (typeof entry === 'string') {
            return [`${dashForm(key)}: ${entry}`];
        }
        let prefix = "";
        // else if it is a typograpghy
        if (typeof entry != 'object') {
            return [];
        }
        const keys = Object.keys(entry);
        if (keys.length == 1 && keys[0] == "var") {
            // variable reference
            const varName = (entry["var"]);
            const mappedName = varLookup(varName);
            if (!mappedName) {
                console.log("Failed to resolve var ", varName);
                return [];
            }
            return [`${dashForm(key)}: var(${mappedName})`];
        }
        else if (key == "border") {
            prefix = "border-";
        }
        else if (key == "typography") {
            prefix = "";
        }
        return keys.map(key => {
            const value = entry[key];
            const renderedValue = renderEntry(value);
            if (renderedValue == null) {
                return null;
            }
            return `${prefix}${dashForm(key)}: ${renderedValue}`;
        }).filter(entry => entry != null);
    }
    function serializeStylingText(moduleStyling, prefix, varLookup) {
        let entries = [];
        for (const key of Object.keys(moduleStyling)) {
            const dashForm = key.replace(/[A-Z]/g, ch => "-" + ch.toLowerCase());
            const styling = moduleStyling[key];
            const stylingKeys = Object.keys(styling);
            const rules = underscore_1.default.flatten(stylingKeys.map((stylingKey) => serializeAsEntries(stylingKey, styling[stylingKey], varLookup)));
            if (prefix == null) {
                prefix = "";
            }
            else if (prefix.length > 0) {
                prefix += " ";
            }
            const ruleString = rules.join(";\n  ");
            entries.push(`${prefix}.${dashForm}
{
  ${ruleString};
}`);
        }
        return entries.join("\n\n");
    }
    function serializeStylingForModule(modules, typeName, name, varLookup) {
        const key = typeName + "." + name;
        if (!modules) {
            return null;
        }
        const moduleStyling = modules[key];
        if (!moduleStyling) {
            return null;
        }
        return serializeStylingText(moduleStyling, "", varLookup);
    }
    function applyTheme(themeEl, theme) {
        const varAssignment = theme2Vars(theme);
        if (!themeEl) {
            return;
        }
        // themeEl['currentThemeDescriptor'] as any = theme;
        for (const varName of Object.keys(varAssignment)) {
            const value = varAssignment[varName];
            themeEl.style.setProperty(varName, value);
        }
    }
    function selectTheme(themeDescriptor, selector) {
        if (!selector) {
            selector = "base";
        }
        const sel = selector;
        return themeDescriptor.themes[sel];
    }
    // is this actually a View?
    class Themeable extends backbone_1.default.View {
        constructor(options) {
            super(options);
        }
        initialize(options) {
            // this el is set.
            if (options.parent) {
                this.parent = options.parent;
            }
            this.selector = options.selector;
            this.model = new backbone_1.default.Model();
            this.listenTo(this.model, "change", this.applyTheme);
            if (options.themeDescriptor && !underscore_1.default.isEmpty(options.themeDescriptor)) {
                this.setThemeDescriptor(options.themeDescriptor);
            }
        }
        applyTheme() {
            applyTheme(this.el, this.model.attributes);
        }
        hasTheme() {
            return !underscore_1.default.isEmpty(this.model.attributes);
        }
        getStyleTextForModule(typeName, name) {
            const prefix = "";
            const varResolver = (name) => {
                return lookupStylingVarName(name, prefix);
            };
            if (!this.themeDescriptor || !this.themeDescriptor.modules) {
                return null;
            }
            return serializeStylingForModule(this.themeDescriptor.modules, typeName, name, varResolver);
        }
        _setTheme(theme) {
            this.model.set(theme || {});
        }
        setThemeDescriptor(descriptor) {
            this.themeDescriptor = descriptor;
            // propagate to children?
            const theme = selectTheme(descriptor, this.selector);
            this.model.set(theme || {});
        }
    }
    exports.Themeable = Themeable;
});
